export default __webpack_public_path__ + "static/media/BodoniModa_10pt-SemiBold.227a78a6.ttf";